<template>
  <div class="information">
    <el-container>

      <el-main style="padding: 2px">
        <el-card   v-auth="'/information/pageList'">
          <el-row :gutter="20">
            <el-col :span="4">
              <el-input
                style="width: 100%"
                :size="componentSize"
                v-model="searchForm.title"
                placeholder="请输入标题"
                auto-complete="off"
                clearable
              ></el-input>
            </el-col>
            <el-col :span="6" style="float: right">
              <el-button
                style="float: right"
                :size="componentSize"
                type="primary"
                @click="pageList"
                icon="el-icon-search"
                v-auth="'/information/pageList'"
                >查询</el-button
              >
              <!-- <el-button
                :size="componentSize"
                type="primary"
                @click="reset"
                icon="el-icon-refresh"
              >重置</el-button> -->
            </el-col>
          </el-row>
        </el-card>

        <el-card style="margin-top: 20px">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane
              :label="item.label"
              :name="item.name"
              v-for="item in tabList"
              :key="item.id"
            >
              <el-row :span="24">
                <el-col :span="12">
                  <el-button
                    v-auth="'/information/addInformation'"
                    :size="componentSize"
                    type="primary"
                    @click="addFormVisible = true"
                    icon="el-icon-plus"
                    >添加</el-button
                  >
                  <el-button
                    :size="componentSize"
                    type="danger"
                    @click="batchDeleteInformation"
                    icon="el-icon-minus"
                    v-auth="'/information/deleteInformation'"
                    >批量删除</el-button
                  >
                </el-col>
                <el-col style="text-align: right" :span="12">
                  <el-button
                    :size="componentSize"
                    type="primary"
                    @click="importFormVisible = true"
                    icon="el-icon-download"
                    v-if="permissions.indexOf('/information/import') > -1"
                    >导入</el-button
                  >
                  <el-button
                    :size="componentSize"
                    style="text-align: right"
                    type="primary"
                    @click="exportExcel"
                    :loading="loading"
                    icon="el-icon-upload2"
                    v-if="permissions.indexOf('/information/export') > -1"
                    >导出</el-button
                  >
                </el-col>
              </el-row>
              <el-table
                :size="componentSize"
                ref="multipleTable"
                :data="page.rows"
                tooltip-effect="dark"
                style="margin-top: 20px; width: 100%"
                border
                v-loading="tableLoading"
                element-loading-text="拼命加载中"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                @selection-change="selectionChange"
              >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column
                  prop="title"
                  label="标题"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="content"
                  label="内容"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column prop="poster" label="海报" width="120">
                  <template slot-scope="scope">
                    <img :src="scope.row.poster" width="100%" height="100px" />
                  </template>
                </el-table-column>
                <el-table-column prop="type" label="类型">
                  <template slot-scope="scope">
                    <span v-if="scope.row.type == 1">行业动态</span>
                    <span v-if="scope.row.type == 2">师资团队</span>
                    <span v-if="scope.row.type == 5">公司新闻</span>
                  </template>
                </el-table-column>
                <!-- <el-table-column prop="sort" label="排序"></el-table-column> -->
                <el-table-column
                  prop="remark"
                  label="备注"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column prop label="状态" width="120" align="center">
                  <template slot-scope="scope">
                    <el-switch
                      @change="active(scope.row)"
                      :active-value="1"
                      :inactive-value="-1"
                      active-text="开"
                      inactive-text="关"
                      class="switchStyle"
                      v-model="scope.row.active"
                    ></el-switch>
                  </template>
                </el-table-column>
                <el-table-column prop label="操作" width="120" align="center">
                  <template slot-scope="scope">
                    <div class="operationGroup">
                      <span @click="(selection = scope.row.id), (editFormVisible = true)"
                            v-auth="'/information/editInformation'"
                      >
                        <i class="information-icon el-icon-edit" title="编辑"></i>
                      </span>
                      <span @click="deleteInformation(scope.row)"     v-auth="'/information/deleteInformationSingle'">
                        <i class="information-icon el-icon-delete" title="删除"></i>
                      </span>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                background
                layout="total, sizes, prev, pager, next, jumper"
                style="margin-top: 20px; text-align: right"
                :total="page.total"
                :page-size="page.pageSize"
                :current-page="page.pageNumber"
                @size-change="sizeChange"
                @current-change="currentChange"
              ></el-pagination>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </el-main>
    </el-container>

    <el-dialog
      title="添加"
      :visible.sync="addFormVisible"
      width="800px"
      left
      :close-on-click-modal="false"
    >
      <!-- <el-dialog title="新增" :visible.sync="addFormVisible" :width="addFormDialogWidth" left v-if="permissions.indexOf('/information/addInformation') > -1"> -->
      <el-form
        ref="addForm"
        :model="addForm"
        :label-width="formLabelWidth"
        :rules="addFormRules"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="海报"
              prop="poster"
              v-if="addForm.type == 1 || addForm.type == 5"
            >
              <el-upload
                class="picture"
                :action="fileAction"
                list-type="picture-card"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
              >
                <img v-if="addForm.poster" :src="addForm.poster" class="avatar" />
                <i v-else class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="老师头像" prop="poster" v-if="addForm.type == 2">
              <el-upload
                class="picture2"
                :action="fileAction"
                list-type="picture-card"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
              >
                <img
                  v-if="addForm.poster"
                  :src="
                    addForm.poster
                      ? addForm.poster
                      : 'https://68wx--test.oss-cn-hangzhou.aliyuncs.com/image/defaultImg.png'
                  "
                  class="avatar"
                />
                <i v-else class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="addForm.type !== 2 ? '标题' : '老师姓名'" prop="title">
              <el-input
                style="width: 100%"
                :size="componentSize"
                v-model="addForm.title"
                :placeholder="addForm.type !== 2 ? '请输入标题' : '请输入老师姓名'"
                auto-complete="off"
                maxlength="255"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序" prop="sort">
              <el-input
                style="width: 100%"
                :size="componentSize"
                type="number"
                v-model="addForm.sort"
                placeholder="请输入排序"
                auto-complete="off"
                maxlength="10"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="老师简介" prop="summary" v-if="addForm.type == 2">
              <el-input
                style="width: 100%"
                :size="componentSize"
                v-model="addForm.summary"
                placeholder="请输入老师简介"
                auto-complete="off"
                show-word-limit
                maxlength="10"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="内容" prop="content" v-if="addForm.type !== 2">
              <div style="background: #fff" v-if="showUe">
                <UE name="1" :value="ueTtext" ref="myQuillEditorTitle"></UE>
              </div>
            </el-form-item>
            <el-form-item label="内容" prop="content" v-if="addForm.type == 2">
              <el-input
                style="width: 100%"
                :size="componentSize"
                type="textarea"
                v-model="addForm.content"
                placeholder="请输入内容"
                auto-complete="off"
                show-word-limit
                maxlength="70"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input
                style="width: 100%"
                :size="componentSize"
                type="textarea"
                v-model="addForm.remark"
                placeholder="请输入备注"
                auto-complete="off"
                maxlength="255"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button :size="componentSize" @click="addFormVisible = false">取 消</el-button>
        <el-button :size="componentSize" type="primary" @click="addInformation"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="查看"
      :visible.sync="detailFormVisible"
      :width="detailFormDialogWidth"
      left
      :close-on-click-modal="false"
      v-if="permissions.indexOf('/information/getInformation') > -1"
    >
      <el-form
        class="detail-form-dialog"
        ref="detailForm"
        :model="detailForm"
        :label-width="formLabelWidth"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="机构id" prop="agentId">{{
              detailForm.agentId
            }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="机构app对应id" prop="agentAppId">{{
              detailForm.agentAppId
            }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="标题" prop="title">{{ detailForm.title }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="内容" prop="content">{{
              detailForm.content
            }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="海报" prop="poster">{{
              detailForm.poster
            }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="类型" prop="type">{{ detailForm.type }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序" prop="sort">{{ detailForm.sort }}</el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注" prop="remark">{{
              detailForm.remark
            }}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      width="800px"
      left
      :close-on-click-modal="false"
    >
      <el-form
        class="edit-form-dialog"
        ref="editForm"
        :model="editForm"
        :label-width="formLabelWidth"
        :rules="editFormRules"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="海报" prop="poster" v-if="editForm.type !== 2">
              <el-upload
                class="picture"
                :action="fileAction"
                list-type="picture-card"
                :show-file-list="false"
                :on-success="editHandleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
              >
                <img
                  v-if="editForm.poster"
                  :src="
                    editForm.poster
                      ? editForm.poster
                      : 'https://68wx--test.oss-cn-hangzhou.aliyuncs.com/image/defaultImg.png'
                  "
                  class="avatar"
                />
                <i v-else class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="老师头像" prop="poster" v-if="editForm.type == 2">
              <el-upload
                class="picture2"
                :action="fileAction"
                list-type="picture-card"
                :show-file-list="false"
                :on-success="editHandleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
              >
                <img
                  style="width=100%"
                  v-if="editForm.poster"
                  :src="
                    editForm.poster
                      ? editForm.poster
                      : 'https://68wx--test.oss-cn-hangzhou.aliyuncs.com/image/defaultImg.png'
                  "
                  class="avatar"
                />
                <i v-else class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="editForm.type !== 2 ? '标题' : '老师姓名'" prop="title">
              <el-input
                style="width: 100%"
                :size="componentSize"
                v-model="editForm.title"
                :placeholder="editForm.type !== 2 ? '请输入标题' : '请输入老师姓名'"
                auto-complete="off"
                maxlength="255"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序" prop="sort">
              <el-input
                style="width: 100%"
                :size="componentSize"
                type="number"
                v-model="editForm.sort"
                placeholder="请输入排序"
                auto-complete="off"
                maxlength="10"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="老师简介" prop="summary" v-if="editForm.type == 2">
              <el-input
                style="width: 100%"
                :size="componentSize"
                v-model="editForm.summary"
                placeholder="请输入老师简介"
                auto-complete="off"
                show-word-limit
                maxlength="10"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="内容" prop="content" v-if="editForm.type !== 2">
              <div style="background: #fff" v-if="showUe">
                <UE name="1" :value="ueTtext" ref="myQuillEditorTitle"></UE>
              </div>
            </el-form-item>
            <el-form-item label="内容" prop="content" v-if="editForm.type == 2">
              <el-input
                style="width: 100%"
                :size="componentSize"
                type="textarea"
                v-model="editForm.content"
                placeholder="请输入内容"
                auto-complete="off"
                show-word-limit
                maxlength="80"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注" prop="remark">
              <el-input
                style="width: 100%"
                :size="componentSize"
                v-model="editForm.remark"
                placeholder="请输入备注"
                auto-complete="off"
                maxlength="255"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button :size="componentSize" @click="editFormVisible = false"
          >取 消</el-button
        >
        <el-button :size="componentSize" type="primary" @click="updateInformation"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="导入"
      :visible.sync="importFormVisible"
      width="80%"
      left
      :close-on-click-modal="false"
      v-if="permissions.indexOf('/information/import') > -1"
    >
      <el-upload
        class="upload-demo"
        :action="fileAction"
        :on-success="handleSuccess"
        :file-list="fileList"
      >
        <el-button :size="componentSize" type="primary" icon="el-icon-upload"
          >点击上传</el-button
        >
        <div slot="tip" class="el-upload__tip">只能上传xls、xlsx文件，且不超过1024kb</div>
      </el-upload>
      <el-table
        :size="componentSize"
        ref="multipleTable"
        :data="importForm.rows"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%"
        border
        @selection-change="selectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="agentId" label="机构id"></el-table-column>
        <el-table-column prop="agentAppId" label="机构app对应id"></el-table-column>
        <el-table-column prop="title" label="标题"></el-table-column>
        <el-table-column prop="content" label="内容"></el-table-column>
        <el-table-column prop="poster" label="海报"></el-table-column>
        <el-table-column prop="type" label="类型"></el-table-column>
        <el-table-column prop="sort" label="排序"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="text-align: left">
        <el-button
          :size="componentSize"
          type="primary"
          @click="importData"
          icon="el-icon-document"
          >导入数据</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import UE from "../conmom/CKEditorInformation.vue";
import {addNews,editNews,delNews} from '../../api/es-search'
export default {
  components: { UE },
  data() {
    return {
      treeLoading: false,
      tableLoading: false,
      blockTreeAdd: false,
      blockTreeEdit: false,
      blockTreeDelete: false,
      blockAddInformation: false,
      blockEditInformation: false,
      blockDeleteInformation: false,
      blockBatchDeleteInformation: false,
      agentAppIdBlock: false,
      agentAppList: [],
      dictionaryIdList: [], // 分类
      dictionaryProps: {
        value: "id",
        label: "name",
        children: "dictionaries",
      },
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1
      },
      componentSize: "",
      addFormDialogWidth: "",
      detailFormDialogWidth: "",
      editFormDialogWidth: "",
      addFormVisible: false,
      detailFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      searchForm: {
        title: null,
        agentAppId: null,
        type: 1,
      },
      addForm: {
        id: null,
        agentId: null,
        agentAppId: null,
        title: null,
        content: null,
        poster: null,
        type: 1,
        sort: null,
        remark: null,
      },
      addFormRules: {
        agentAppId: [
          {
            required: true,
            message: "请选择机构app",
            trigger: "change",
          },
        ],
        title: [
          {
            required: true,
            message: "请输入标题",
            trigger: "blur",
          },
          {
            min: 0,
            max: 255,
            message: "标题长度在0-255个字",
          },
        ],
        summary: [
          {
            required: true,
            message: "请输入老师简介",
            trigger: "blur",
          },
        ],
        dictionaryId: [
          {
            required: true,
            message: "请选择地区",
            trigger: "chaneg",
          },
        ],
        content: [
          {
            required: true,
            message: "请输入内容",
            trigger: "blur",
          },
          {
            min: 0,
            max: 65535,
            message: "内容长度在0-65535个字",
          },
        ],
        poster: [
          {
            required: true,
            message: "请上传海报",
            trigger: "blur",
          },
          {
            min: 0,
            max: 255,
            message: "海报长度在0-255个字",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择类型",
            trigger: "change",
          },
        ],
        sort: [
          {
            required: true,
            message: "请输入排序",
            trigger: "blur",
          },
        ],
      },
      detailForm: {
        id: null,
        agentId: null,
        agentAppId: null,
        title: null,
        content: null,
        poster: null,
        type: null,
        sort: null,
        remark: null,
      },
      editForm: {
        id: null,
        agentId: null,
        agentAppId: null,
        title: null,
        content: null,
        poster: null,
        type: null,
        sort: null,
        remark: null,
      },
      editFormRules: {
        title: [
          {
            required: true,
            message: "请输入标题",
            trigger: "blur",
          },
          {
            min: 0,
            max: 255,
            message: "标题长度在0-255个字",
          },
        ],
        summary: [
          {
            required: true,
            message: "请输入老师简介",
            trigger: "blur",
          },
        ],
        dictionaryId: [
          {
            required: true,
            message: "请选择地区",
            trigger: "chaneg",
          },
        ],
        content: [
          {
            required: true,
            message: "请输入内容",
            trigger: "blur",
          },
          {
            min: 0,
            max: 65535,
            message: "内容长度在0-65535个字",
          },
        ],
        poster: [
          {
            required: true,
            message: "请上传海报",
            trigger: "change",
          },
          {
            min: 0,
            max: 255,
            message: "海报长度在0-255个字",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择类型",
            trigger: "change",
          },
        ],
        sort: [
          {
            required: true,
            message: "请输入排序",
            trigger: "blur",
          },
        ],
      },
      importForm: {},
      searchFormLabelWidth: "0px",
      formLabelWidth: "80px",
      treeSelection: "",
      selection: "",
      multipleSelection: "",
      ids: [],
      ueTtext: "",
      showUe: false,
      rangePickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近六个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      fileAction: `${process.env.POI_URL}/information/upload`,
      fileList: [],
      loading: false,
      permissions: [],
      filter: "",
      treeData: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      activeName: "1",
      tabList: [
        {
          id: 1,
          name: "1",
          label: "行业动态",
        },
        {
          id: 5,
          name: "5",
          label: "公司新闻",
        },
        {
          id: 2,
          name: "2",
          label: "师资团队",
        },
      ],
    };
  },
  methods: {
    handleClick(tab) {
      console.log(tab);
      this.searchForm.type = tab.name;
      this.addForm.type = parseInt(tab.name);
      this.searchForm.title = "";
      this.pageList();
      console.log(1424, tab.label);
      console.log(1424, tab.name);
    },
    handleAvatarSuccess(res, file) {
      this.addForm.poster = res.data.split("?")[0];
    },
    editHandleAvatarSuccess(res, file) {
      this.editForm.poster = res.data.split("?")[0];
    },
    beforeAvatarUpload(file) {
      // const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      // if (!isJPG) {
      //   this.$message.error("上传头像图片只能是 JPG 格式!");
      // }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    setComponentSize() {
      if (document.body.clientWidth <= 992) {
        this.componentSize = "mini";
        return;
      }
      if (document.body.clientWidth <= 1200) {
        this.componentSize = "small";
        return;
      }
      if (document.body.clientWidth <= 1920) {
        this.componentSize = "medium";
        return;
      }
    },
    setDialogWidth() {
      if (document.body.clientWidth > 1366) {
        this.addFormDialogWidth = "60%";
      } else {
        this.addFormDialogWidth = "75%";
      }
      if (document.body.clientWidth > 1366) {
        this.detailFormDialogWidth = "60%";
      } else {
        this.detailFormDialogWidth = "75%";
      }
      if (document.body.clientWidth > 1366) {
        this.editFormDialogWidth = "60%";
      } else {
        this.editFormDialogWidth = "75%";
      }
      if (document.body.clientWidth > 1366) {
        this.treeAddFormDialogWidth = "60%";
      } else {
        this.treeAddFormDialogWidth = "75%";
      }
      if (document.body.clientWidth > 1366) {
        this.treeEditFormDialogWidth = "60%";
      } else {
        this.treeEditFormDialogWidth = "75%";
      }
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange(val) {
      this.multipleSelection = val;
      val.map((e) => this.ids.push({ id: e.id }));
    },
    getInformationDetail() {
      this.api.information
        .getInformationDetail({
          id: this.selection,
        })
        .then((result) => {
          if (result.success) {
            this.detailForm = result.data;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 获取分类
    getDictionaryTreeByParentId() {
      this.api.dictionary
        .getDictionaryTreeByParentId({ id: "1400364792484573186" })
        .then((res) => {
          this.dictionaryIdList = this.getTreeData(res.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getTreeData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].dictionaries.length === 0) {
          data[i].dictionaries = undefined;
        } else {
          this.getTreeData(data[i].dictionaries);
        }
      }
      return data;
    },
    getAgentAppList() {
      this.api.agentApp
        .getAgentAppList({type: 1})
        .then((result) => {
          if (result.success) {
            this.agentAppList = result.data;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getInformation() {
      this.api.information
        .getInformation({
          id: this.selection,
        })
        .then((result) => {
          if (result.success) {
            this.$set(this, "editForm", result.data);
            if (this.editForm.type !== 2) {
              this.ueTtext = this.editForm.content;
              this.showUe = true;
            }
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    pageList() {
      this.tableLoading = true;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.api.information
        .pageList(this.searchForm)
        .then((result) => {
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
          this.tableLoading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addInformation() {
      if (this.blockAddInformation) {
        return false;
      }
      if (this.addForm.type !== 2) {
        console.log(this.$refs.myQuillEditorTitle._data.content,332);
        if (this.$refs.myQuillEditorTitle._data.content) {
          this.addForm.content = this.$refs.myQuillEditorTitle._data.content;
          
          this.$refs.addForm.validate((valid) => {
            if (valid) {
              if (
                this.addForm.dictionaryId &&
                typeof this.addForm.dictionaryId !== "string"
              ) {
                let len = this.addForm.dictionaryId.length;
                this.addForm.dictionaryId = this.addForm.dictionaryId[len - 1];
              }
              this.blockAddInformation = true;
              this.api.information
                .addInformation(this.addForm)
                .then((result) => {
                  this.blockAddInformation = false;
                  if (result.success) {
                    this.$message.success(result.message);
                    this.addFormVisible = false;
                    this.showUe = false;
                    // TODO 埋点
                    addNews(result.data).then(res=>{console.log(1)})
                    this.pageList();
                  } else {
                    this.$message.error(result.message);
                  }
                })
                .catch((error) => {
                  this.blockAddInformation = false;
                  console.log(error);
                });
            } else {
              return false;
            }
          });
        } else {
          this.$message.error("内容不能为空");
        }
      } else {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.blockAddInformation = true;
            this.api.information
              .addInformation(this.addForm)
              .then((result) => {
                this.blockAddInformation = false;
                if (result.success) {
                  this.$message.success(result.message);
                  this.addFormVisible = false;
                  this.pageList();
                } else {
                  this.$message.error(result.message);
                }
              })
              .catch((error) => {
                this.blockAddInformation = false;
                console.log(error);
              });
          } else {
            return false;
          }
        });
      }
    },
    updateInformation() {
      if (this.blockEditInformation) {
        return false;
      }
      if (this.editForm.type !== 2) {
        if (this.$refs.myQuillEditorTitle._data.content) {
          this.editForm.content = this.$refs.myQuillEditorTitle._data.content;
          this.$refs.editForm.validate((valid) => {
            if (valid) {
              if (
                this.editForm.dictionaryId &&
                typeof this.editForm.dictionaryId !== "string"
              ) {
                let len = this.editForm.dictionaryId.length;
                this.editForm.dictionaryId = this.editForm.dictionaryId[len - 1];
              }
              this.blockEditInformation = true;
              this.api.information
                .updateInformation(this.editForm)
                .then((result) => {
                  this.blockEditInformation = false;
                  if (result.success) {
                    this.$message.success(result.message);
                    this.editFormVisible = false;
                    this.showUe = false;
                    // TODO 埋点
                    editNews(this.editForm.id).then(res=>{console.log(1)})
                    this.pageList();
                  } else {
                    this.$message.error(result.message);
                  }
                })
                .catch((error) => {
                  this.blockEditInformation = false;
                  console.log(error);
                });
            } else {
              return false;
            }
          });
        }
      } else {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.blockEditInformation = true;
            this.api.information
              .updateInformation(this.editForm)
              .then((result) => {
                this.blockEditInformation = false;
                if (result.success) {
                  this.$message.success(result.message);
                  this.editFormVisible = false;
                  this.pageList();
                } else {
                  this.$message.error(result.message);
                }
              })
              .catch((error) => {
                this.blockEditInformation = false;
                console.log(error);
              });
          } else {
            return false;
          }
        });
      }
    },
    deleteInformation(row) {
      if (this.blockDeleteInformation) {
        return false;
      }
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.blockDeleteInformation = true;
          this.api.information
            .deleteInformation([
              {
                id: row.id,
              },
            ])
            .then((result) => {
              this.blockDeleteInformation = false;
              if (result.success) {
                this.$message.success(result.message);
                // TODO 埋点
                delNews([row.id]).then(res=>{console.log(1)})
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              this.blockDeleteInformation = false;
              console.log(error);
            });
        })
        .catch(() => {});
    },
    batchDeleteInformation() {
      if (this.blockBatchDeleteInformation) {
        return false;
      }
      if (this.ids.length === 0) {
        this.$message.error("请选择要删除的数据！");
        return false;
      }
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.blockBatchDeleteInformation = true;
          this.api.information
            .deleteInformation(this.ids)
            .then((result) => {
              if (result.success) {
                this.$message.success(result.message);
                // TODO
                let arr = []
                for (const id of this.ids) {
                  arr.push(id.id)
                }
                delNews(arr).then(res=>{console.log(1)})
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
              this.blockBatchDeleteInformation = false;
            })
            .catch((error) => {
              this.blockBatchDeleteInformation = false;
              console.log(error);
            });
        })
        .catch(() => {});
    },
    reset() {
      this.$refs.searchForm.resetFields();
      this.pageList();
    },
    handleSuccess(response, file, fileList, $event) {
      this.importForm = response.data;
    },
    exportExcel() {
      this.loading = true;
      this.api.information
        .exportExcel(this.searchForm)
        .then((result) => {
          location.href = result.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    importData() {
      this.api.information
        .importData(this.importForm.rows)
        .then((result) => {
          if (result.success) {
            this.$message.success(result.message);
            this.importFormVisible = false;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getTree() {
      this.treeLoading = true;
      this.api.information
        .getTree({})
        .then((result) => {
          if (result.success) {
            this.treeData = result.data;
            if (this.treeData !== null && this.treeData.length > 0) {
              this.pageList();
            }
            this.treeLoading = false;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleNodeClick(data) {
      if (!data.disabled) {
        this.pageList();
      }
    },
    active(row) {
      let obj = {
        id: row.id,
        active: row.active,
      };
      this.api.information
        .active(obj)
        .then((result) => {
          if (result.success) {
            this.$message.success(result.message);
            // TODO 埋点
            if(row.active == 1){ // 开
              addNews(row.id).then(res=>{console.log(1)})
            }else{
              delNews([row.id]).then(res=>{console.log(1)})
            }
          } else {
            this.$message.error(result.message);
          }
          this.pageList();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getPermissionList() {
      let user = JSON.parse(localStorage.user);
      user.resources.forEach((e) => {
        e.resources.forEach((a) => {
          a.resources.forEach((x) => this.permissions.push(x.url));
        });
      });
    },
  },
  watch: {
    addFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        // this.$refs.myQuillEditorTitle._data.content = "";
        this.addForm.type = 1;
        this.showUe = false;
        this.ueTtext = "";
        // this.pageList();
      } else {
        this.getDictionaryTreeByParentId();
        this.showUe = true;
        this.getAgentAppList();
      }
    },
    detailFormVisible: function (newVal) {
      if (newVal) {
        let loading = this.$loading.service({
          text: "请稍等",
          target: document.querySelector(".detail-form-dialog"),
        });
        this.getInformationDetail();
        loading.close();
      }
    },
    editFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.editForm.resetFields();
        this.showUe = false;
        this.ueTtext = "";
      } else {
        let loading = this.$loading.service({
          text: "请稍等",
          target: document.querySelector(".edit-form-dialog"),
        });
        this.getDictionaryTreeByParentId();
        this.getAgentAppList();
        this.getInformation();
        loading.close();
      }
    },
  },
  mounted() {
    if (JSON.parse(localStorage.getItem("user")).agentId == "621995219419136") {
      this.agentAppIdBlock = true;
    } else {
      this.agentAppIdBlock = false;
    }
    this.setComponentSize();
    this.setDialogWidth();
    // this.getPermissionList()
    // this.getTree()
    this.pageList();
    this.getAgentAppList();
  },
};
</script>
<style scoped>
.information-icon {
  font-size: 16px;
  color: #4d94ff;
}
</style>
<style lang="less" rel="stylesheet/less">
.information {
  .el-textarea__inner {
    padding: 5px 45px 5px 15px;
  }
  .avatar-uploader .el-upload {
    // border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .picture {
    .el-upload--picture-card {
      width: 130px;
      height: 100px;
      line-height: 110px;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 130px;
      height: 100px;
      text-align: center;
    }
    .avatar {
      border: 1px solid #c0ccda;
      width: 130px;
      height: 100px;
      display: block;
    }
  }
  .picture {
    .el-upload--picture-card i {
      margin: auto !important;
      line-height: 100px !important;
    }
  }
  .picture2 {
    .el-upload--picture-card {
      width: 100px;
      height: 100px;
      line-height: 110px;
      i {
        line-height: 100px !important;
        margin: auto !important;
      }
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 100px;
      height: 100px;
      text-align: center;
    }
    .avatar {
      border: 1px solid #c0ccda;
      width: 100px;
      height: 100px;
      display: block;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/information/index.vue